// src/helpers/callCenterFlags.js
//
// Feature flag del módulo Call Center (llamadas grabadas por la app de
// escritorio). La UI (tabs "Llamadas" en ClienteDetalle y DetalleDeuda) y el
// servicio de llamadas viven en el bundle, pero se muestran SOLO cuando el
// ambiente lo habilita explícitamente.
//
// Contrato: se habilita únicamente si REACT_APP_CALL_CENTER_UI === "1".
//   - env/playground.env  → "1"  (ahí se prueba la app desktop)
//   - env/prod.env        → "0"  (queda oculto hasta el "push próximo")
//   - dev local (npm start): agrega REACT_APP_CALL_CENTER_UI=1 en .env.local
//     si quieres ver el módulo mientras desarrollas.
//
// Para encender en prod en el futuro: pon "1" en env/prod.env, redeploy de
// hosting y despliega la función procesarLlamada + reglas/índices de llamadas.

export const isCallCenterUiEnabled = () =>
  String(process.env.REACT_APP_CALL_CENTER_UI || "") === "1";
